import React from 'react';
import {HttpErrorScreen, LoadScreen} from 'epic-fortnite-react/components';
import {getInitialCmsPageSharedValues, useCmsData, PageData} from 'epic-fortnite-shared-values';
import MetaTags from '../../components/common/MetaTags';
import {Locale} from '@epic-core/config';
import {withLocalization} from '@epic-core/localization';

const SLUG = 'paymentsact';

interface PaymentsActData extends PageData {
  fundsSettlementActTitle: string;
  fundsSettlementAct: string;
  commercialTransactionsTitle: string;
  commercialTransactions: string;
}

interface LocalizationProps {
  locale: Locale;
}

const PaymentsActView = ({locale}: LocalizationProps) => {
  const {pageData, isLoading, error} = useCmsData<PaymentsActData>(SLUG);

  if (isLoading) {
    return <LoadScreen show={true} />;
  }

  if (error) {
    return <HttpErrorScreen statusCode={error.response?.status ?? 500} />;
  }

  // return a 404 if the pageData is not found and if locale is not equal to 'ja'
  if (!pageData || locale !== 'ja') {
    return <HttpErrorScreen statusCode={404} />;
  }

  return (
    <div className="paymentsact-view-container">
      <MetaTags pageModel={pageData} />
      <div className="light-bg">
        <div id="paymentsactContainer" className="container paymentsact">
          <div className="site-block paymentsact-container">
            <div className="site-block-header">
              <h1 className="site-block-title pull-left paymentsact-title">
                {pageData.fundsSettlementActTitle}
              </h1>
              <div className="clearfix" />
            </div>
            <div className="site-block-body">
              <div
                className="site-block-body-text paymentsact-text"
                dangerouslySetInnerHTML={{__html: pageData.fundsSettlementAct}}
              />
            </div>
            <div className="site-block-header">
              <h1 className="site-block-title pull-left paymentsact-title">
                {pageData.commercialTransactionsTitle}
              </h1>
              <div className="clearfix" />
            </div>
            <div className="site-block-body">
              <div
                className="site-block-body-text paymentsact-text"
                dangerouslySetInnerHTML={{__html: pageData.commercialTransactions}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PaymentsActView.getInitialSharedValues = getInitialCmsPageSharedValues(SLUG);

export default withLocalization(PaymentsActView);
